// import React, { useState, useEffect } from "react";
// import "./ReportWhatsapp.css";
// import DropDown from "../AssignTest/Dropdown";
// import { API_BASE_URL } from "../../Config/Config";
// import InterogativeImg from "../../Assets/Images/CommanImages/Interogative.png";
// import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
// import StudentLogo from "../../Assets/Images/CommanImages/studentforsearch.png";
// import Search from "../../Assets/Images/CommanImages/searchyellow.png";

// const ReportWhatsapp = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   setNoTimeSet
// }) => {
//   const [courses, setCourses] = useState([]);
//   const [courseOpted, setCourseOpted] = useState("");
//   const [batches, setBatches] = useState([]);
//   const [searchKeySecond, setSearchKeySecond] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [isDropdownVisible, setIsDropdownVisible] = useState(false);
//   const [selectedStudent, setSelectedStudent] = useState({ name: "", id: null });
//   const [whatsappFlag, setWhatsappFlag] = useState(false);
//   const [downloadFlag, setDownloadFlag] = useState(false);
//   const [selectedBatchId, setSelectedBatchId] = useState("");
//   const [batchnameByCourseID, setBatchNameByCourseID] = useState("");

//   const handleCancel = () => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Are you sure you want to cancel?</span>
//         </div>
//         <div className="messagebox-insider2">
//           <button
//             className="messagebox-cancel-btn"
//             style={{ marginRight: "10px" }}
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             CANCEL
//           </button>
//           <button
//             className="testreportcard-create-btn"
//             onClick={() => window.location.reload()}
//           >
//             PROCEED
//           </button>
//         </div>
//       </div>
//     );
//     setTimeout(() => setIsMessageBoxVisible(false), 9000);
//     setActiveImg(InterogativeImg);
//   };

//   // Fetch Courses
//   useEffect(() => {
//     const fetchCourses = async () => {
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-courses/`
//         );
//         const data = await response.json();
//         setCourses(data);
//       } catch (error) {
//         console.error("Error fetching courses:", error);
//       }
//     };
//     fetchCourses();
//   }, []);

//   // Fetch Batches based on selected course
//   useEffect(() => {
//     const fetchBatches = async () => {
//       if (courseOpted) {
//         try {
//           const response = await fetch(
//             `http://127.0.0.1:8000/coaching-collaborator-api/api/v1/get-batch-name-by-course-id/?course_id=${courseOpted}`
//           );
//           const data = await response.json();
//           setBatchNameByCourseID(data);
//         } catch (error) {
//           console.error("Error fetching batches:", error);
//         }
//       }
//     };
//     fetchBatches();
//   }, [courseOpted]);

//   // Fetch Student Search Results
//   useEffect(() => {
//     const handleSearch = async () => {
//       if (searchKeySecond.length >= 3 && selectedBatchId) {
//         try {
//           const response = await fetch(
//             `http://127.0.0.1:8000/coaching-collaborator-api/api/v1/get-student-by-batch-list-report-searchkey/?search_key=${searchKeySecond}&batch_ids=${selectedBatchId}`
//           );
//           const data = await response.json();
//           setSearchResults(data);
//         } catch (error) {
//           console.error(error);
//         }
//       } else {
//         setSearchResults([]);
//       }
//     };
//     handleSearch();
//   }, [searchKeySecond, selectedBatchId]);

//   const formatStudentName = (fullName) => {
//     if (!fullName) return "";
//     const nameParts = fullName.split(", ");
//     return nameParts.length === 2 ? `${nameParts[1]} ${nameParts[0]}` : fullName;
//   };

//   const handleStudentSelect = (student) => {
//     setSelectedStudent({ name: student.student_name, id: student.student_id });
//     setSearchKeySecond(formatStudentName(student.student_name));
//     setIsDropdownVisible(false);
//   };

  
//   const handleGenerateClick = async () => {
//     // Validation for course and batch selection
//     if (!courseOpted) {
//       showErrorMessage("Please select a course.");
//       return;
//     }
//     if (!selectedBatchId) {
//       showErrorMessage("Please select a batch.");
//       return;
//     }
//     if (!whatsappFlag && !downloadFlag) {
//       showErrorMessage("Please select at least one option: WhatsApp or Download Report.");
//       return;
//     }
  
//     // Show message box while generating the report
//     setIsMessageBoxVisible(true);
//     setNoTimeSet(true); // Disable timer to keep message box open
  
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>{whatsappFlag ? "Sending Result..." : "Generating Result..."}</span>
//         </div>
//       </div>
//     );
  
//     const url = `http://127.0.0.1:8000/coaching-collaborator-api/api/v1/report-plot-n-send?batch_id=${selectedBatchId}${
//       selectedStudent.id ? `&student_id=${selectedStudent.id}` : ""
//     }&whatsapp_message_send_flag=${whatsappFlag}&download_reports_flag=${downloadFlag}`;
  
//     try {
//       const headers = downloadFlag ? { accept: "application/zip" } : {};
//       const response = await fetch(url, { method: "GET", headers });
  
//       if (response.ok) {
//         // Read the response as JSON (single read)
//         const jsonResponse = await response.json();
  
//         // If download URL is present and download flag is true, handle the ZIP download
//         if (downloadFlag && jsonResponse.download_url) {
//           const downloadUrl = jsonResponse.download_url;
//           const link = document.createElement("a");
//           link.href = downloadUrl;
//           link.download = "reports.zip"; // Default filename for download
//           document.body.appendChild(link);
//           link.click();
//           document.body.removeChild(link);
  
//           // Show success message for ZIP download
//           showSuccessMessage("Report Generation Complete. ZIP File Downloaded.");
//         }
  
//         // If WhatsApp flag is true and WhatsApp response is present, handle the response
//         if (whatsappFlag && jsonResponse.whatsapp_response) {
//           handleWhatsAppJsonResponse(jsonResponse.whatsapp_response);
//         }
//       } else {
//         showErrorMessage("Error generating report");
//       }
//     } catch (error) {
//       console.error(error);
//       showErrorMessage("An error occurred while generating the report.");
//     } finally {
//       // Re-enable the timer and close the message box after process is done
//       setNoTimeSet(false);
//       setTimeout(() => setIsMessageBoxVisible(false), 5000);
//     }
//   };
  
//   // Handle WhatsApp JSON Response and download as text file if needed
//   const handleWhatsAppJsonResponse = (whatsappResponse) => {
//     // Convert the WhatsApp response to a JSON string
//     const jsonString = JSON.stringify(whatsappResponse, null, 2); // Pretty format JSON
//     const blob = new Blob([jsonString], { type: "text/plain" });
//     const downloadUrl = window.URL.createObjectURL(blob);
  
//     // Display the WhatsApp response with an option to download as a text file
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>
//             WhatsApp response received.{" "}
//             <a href={downloadUrl} download="whatsapp-response.txt">
//               Download response as text file
//             </a>
//           </span>
//         </div>
//       </div>
//     );
//   };
  
  
  
  


//   const showErrorMessage = (message) => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>{message}</span>
//         </div>
//         <div className="messagebox-insider2">
//           <button className="messagebox-cancel-btn" onClick={() => setIsMessageBoxVisible(false)}>
//             OK
//           </button>
//         </div>
//       </div>
//     );
//     setActiveImg(ErrorImg);
//     setTimeout(() => {
//       setIsMessageBoxVisible(false);
//     }, 5000);
//   };

//   const showSuccessMessage = (message) => {
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>{message}</span>
//         </div>
//         <div className="messagebox-insider2">
//           <button className="messagebox-cancel-btn" onClick={() => setIsMessageBoxVisible(false)}>
//             OK
//           </button>
//         </div>
//       </div>
//     );
//     setTimeout(() => {
//       setIsMessageBoxVisible(false);
//     }, 5000);
//   };

//   return (
//     <div style={{ height: "auto", width: "100%", paddingLeft: "20px", marginBottom: "40px" }}>
//       <div className="container-UP" style={{ position: "sticky", top: "0" }}>
//         <div className="Header-up">
//           <p className="title-cb">Report WhatsApp</p>
//           <div className="mb-2-UP grey-color-font">
//             <button className="cr-cancel-btn me-cs4" onClick={handleCancel}>
//               CANCEL
//             </button>
//             <button className="cr-create-btn" onClick={handleGenerateClick}>
//               GENERATE
//             </button>
//           </div>
//         </div>
//         <hr className="hr-otc" />
//       </div>

//       <div style={{ paddingLeft: "15px", paddingTop: "15px", paddingBottom: "8px" }}>
//         <p className="color424342" style={{ marginBottom: "15px", fontSize: "16px" }}>
//           Report generation and Report sending to WhatsApp
//         </p>
//         <div style={{ display: "flex" }}>
//           <DropDown
//             key="course-dropdown"
//             setSelected={setCourseOpted}
//             options={courses.map((course) => ({
//               label: course.course_name,
//               id: course.course_id,
//             }))}
//             Height="auto"
//             minheight="150px"
//             OverFlow="auto"
//             customWidth="300px"
//             label="Course"
//           />
//           <div className="whatsapp-div color424342" style={{ paddingLeft: "40px" }}>
//             <ul>
//               <li style={{ paddingBottom: "8px" }}>
//                 <label style={{ padding: "" }}>WhatsApp</label>
//               </li>
//               <li>
//                 <label className={`switch user-status ${whatsappFlag ? "no-border" : ""}`}>
//                   <input
//                     type="checkbox"
//                     checked={whatsappFlag}
//                     onChange={() => setWhatsappFlag(!whatsappFlag)}
//                   />
//                   <span className="slider round"></span>
//                 </label>
//               </li>
//             </ul>
//           </div>
//         </div>

//         <div style={{ display: "flex" }}>
//           <DropDown
//             key="batch-dropdown"
//             // setSelected={setSelectedBatchId}
//             setSelected={(batchId) => {
//               setSelectedBatchId(batchId); // Set the selected batch
//               setSelectedStudent({ name: "", id: null }); // Clear the selected student
//               setSearchKeySecond(""); // Clear the search input field
//             }}
//             options={
//               batchnameByCourseID && Array.isArray(batchnameByCourseID[0])
//                 ? batchnameByCourseID[0].map((batch) => ({
//                     label: batch.batch_name,
//                     id: batch.batch_id,
//                   }))
//                 : []
//             }
//             Height="auto"
//             minheight="150px"
//             OverFlow="auto"
//             customWidth="300px"
//             label="Batch"
//             onClick={()=>{
//               setSelectedStudent({ name: "", id: null });
//               setSearchKeySecond("")
//             }}
//           />
//           <div className="whatsapp-div color424342" style={{ paddingLeft: "40px" }}>
//             <ul>
//               <li style={{ paddingBottom: "8px" }}>
//                 <label>Download Report</label>
//               </li>
//               <li>
//                 <label className={`switch user-status ${downloadFlag ? "no-border" : ""}`}>
//                   <input
//                     type="checkbox"
//                     checked={downloadFlag}
//                     onChange={() => setDownloadFlag(!downloadFlag)}
//                   />
//                   <span className="slider round"></span>
//                 </label>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </div>

//       <label style={{ color: "#424242", marginLeft: "15px" }}>Search Student</label>
//       <div
//         style={{
//           marginTop: "8px",
//           border: "1px solid grey",
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           width: "300px",
//           marginLeft: "0.85vw",
//         }}
//       >
//         <input
//           style={{
//             backgroundColor: "white",
//             outline: "none",
//             padding: "10px",
//             width: "70vw",
//             height: "3.4vh",
//             border: "none",
//           }}
//           type="text"
//           placeholder="Type here to search"
//           name="search"
//           value={searchKeySecond}
//           onChange={(e) => setSearchKeySecond(e.target.value)}
//           onFocus={() => setIsDropdownVisible(true)}
//           onBlur={() => setTimeout(() => setIsDropdownVisible(false), 200)}
//         />
//         <img
//           style={{ height: "3.4vh", width: "2vw", backgroundColor: "none", padding: "4px" }}
//           src={Search}
//           alt="search"
//         />
//         {isDropdownVisible && searchResults.length > 0 && (
//           <div className="search-results-dropdown">
//             {searchResults.map((result, index) => (
//               <div key={index} className="search-result-item" onClick={() => handleStudentSelect(result)}>
//                 <p className="first-item-student">
//                   <img
//                     src={StudentLogo}
//                     style={{
//                       height: "25px",
//                       width: "25px",
//                       marginRight: "4px",
//                     }}
//                     alt=""
//                   />
//                   {formatStudentName(result.student_name)}
//                 </p>
//                 <p style={{ marginTop: "5px" }} className="second-item-student">
//                   {/* Batch: {result.batch_name} */}
//                 </p>
//                 <p className="second-item-student">Roll No: {result.student_roll_no}</p>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ReportWhatsapp;





























import React, { useState, useEffect } from "react";
import "./ReportWhatsapp.css";
import DropDown from "./Dropdown/Dropdown";
import InterogativeImg from "../../Assets/Images/CommanImages/Interogative.png";
import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
import StudentLogo from "../../Assets/Images/CommanImages/studentforsearch.png";
import Search from "../../Assets/Images/CommanImages/searchyellow.png";
import { API_BASE_URL } from "../../Config/Config";

const ReportWhatsapp = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  setNoTimeSet
}) => {
  const [courses, setCourses] = useState([]);
  const [courseOpted, setCourseOpted] = useState("");
  const [batchnameByCourseID, setBatchNameByCourseID] = useState([]);
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [selectedStudent, setSelectedStudent] = useState({ name: "", id: null });
  const [searchKeySecond, setSearchKeySecond] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [whatsappFlag, setWhatsappFlag] = useState(false);
  const [downloadFlag, setDownloadFlag] = useState(false);
  const [selectedCourseLabel, setSelectedCourseLabel] = useState("");  // Track selected course
  const [selectedBatchLabel, setSelectedBatchLabel] = useState("");    // Track selected batch

  const handleCancel = () => {
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>Are you sure you want to cancel?</span>
        </div>
        <div className="messagebox-insider2">
          <button
            className="messagebox-cancel-btn"
            style={{ marginRight: "10px" }}
            onClick={() => setIsMessageBoxVisible(false)}
          >
            CANCEL
          </button>
          <button
            className="testreportcard-create-btn"
            onClick={() => window.location.reload()}
          >
            PROCEED
          </button>
        </div>
      </div>
    );
    setTimeout(() => setIsMessageBoxVisible(false), 9000);
    setActiveImg(InterogativeImg);
  };

  
  // Fetch Courses
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-courses/`
        );
        const data = await response.json();
        setCourses(data);
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };
    fetchCourses();
  }, []);

  // Fetch batches for the selected course
  const fetchBatchesForCourse = async (courseId) => {
    if (courseId) {
      try {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batch-name-by-course-id/?course_id=${courseId}`
        );
        const data = await response.json();
        setBatchNameByCourseID(data);
      } catch (error) {
        console.error("Error fetching batches:", error);
      }
    }
  };

  useEffect(() => {
    const handleSearch = async () => {
      if (searchKeySecond.length >= 3 && selectedBatchId) {
        try {
          const response = await fetch(
            `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-student-by-batch-list-report-searchkey/?search_key=${searchKeySecond}&batch_ids=${selectedBatchId}`
          );
          const data = await response.json();
          setSearchResults(data);
        } catch (error) {
          console.error(error);
        }
      } else {
        setSearchResults([]);
      }
    };
    handleSearch();
  }, [searchKeySecond, selectedBatchId]);

  // Handle Student Selection
  const handleStudentSelect = (student) => {
    setSelectedStudent({ name: student.student_name, id: student.student_id });
    setSearchKeySecond(formatStudentName(student.student_name));
    setIsDropdownVisible(false); // Hide the dropdown after selecting a student
  };

  // Format the student's name
  const formatStudentName = (fullName) => {
    if (!fullName) return "";
    const nameParts = fullName.split(", ");
    return nameParts.length === 2 ? `${nameParts[1]} ${nameParts[0]}` : fullName;
  };

  // Handle Generate Report
  const handleGenerateClick = async () => {
    if (!courseOpted) {
      showErrorMessage("Please select a course.");
      return;
    }
    if (!selectedBatchId) {
      showErrorMessage("Please select a batch.");
      return;
    }
    if (!whatsappFlag && !downloadFlag) {
      showErrorMessage("Please select at least one option: WhatsApp or Download Report.");
      return;
    }

    // Show message box while generating the report
    setIsMessageBoxVisible(true);
    setNoTimeSet(true); // Disable timer to keep message box open

    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>{whatsappFlag ? "Sending Result..." : "Generating Result..."}</span>
        </div>
      </div>
    );

    const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/report-plot-n-send?batch_id=${selectedBatchId}${
      selectedStudent.id ? `&student_id=${selectedStudent.id}` : ""
    }&whatsapp_message_send_flag=${whatsappFlag}&download_reports_flag=${downloadFlag}`;

    try {
      const headers = downloadFlag ? { accept: "application/zip" } : {};
      const response = await fetch(url, { method: "GET", headers });

      if (response.ok) {
        const jsonResponse = await response.json();

        if (downloadFlag && jsonResponse.download_url) {
          const downloadUrl = jsonResponse.download_url;
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = "reports.zip";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          showSuccessMessage("Report Generation Complete. ZIP File Downloaded.");
        }

        if (whatsappFlag && jsonResponse.whatsapp_response) {
          handleWhatsAppJsonResponse(jsonResponse.whatsapp_response);
        }
      } else {
        showErrorMessage("Error generating report");
      }
    } catch (error) {
      console.error(error);
      showErrorMessage("An error occurred while generating the report.");
    } finally {
      setNoTimeSet(false);
      setTimeout(() => setIsMessageBoxVisible(false), 5000);
    }
  };

  // Handle WhatsApp JSON Response
  const handleWhatsAppJsonResponse = (whatsappResponse) => {
    const jsonString = JSON.stringify(whatsappResponse, null, 2); // Pretty format JSON
    const blob = new Blob([jsonString], { type: "text/plain" });
    const downloadUrl = window.URL.createObjectURL(blob);

    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>
            WhatsApp response received.{" "}
            <a href={downloadUrl} download="whatsapp-response.txt">
              Download response as text file
            </a>
          </span>
        </div>
      </div>
    );
  };

  const showErrorMessage = (message) => {
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>{message}</span>
        </div>
        <div className="messagebox-insider2">
          <button className="messagebox-cancel-btn" onClick={() => setIsMessageBoxVisible(false)}>
            OK
          </button>
        </div>
      </div>
    );
    setActiveImg(ErrorImg);
    setTimeout(() => {
      setIsMessageBoxVisible(false);
    }, 5000);
  };

  const showSuccessMessage = (message) => {
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>{message}</span>
        </div>
        <div className="messagebox-insider2">
          <button className="messagebox-cancel-btn" onClick={() => setIsMessageBoxVisible(false)}>
            OK
          </button>
        </div>
      </div>
    );
    setTimeout(() => {
      setIsMessageBoxVisible(false);
    }, 5000);
  };

  return (
    <div style={{ height: "auto", width: "100%", paddingLeft: "20px", marginBottom: "40px" }}>
      <div className="container-UP" style={{ position: "sticky", top: "0" }}>
        <div className="Header-up">
          <p className="title-cb">Report WhatsApp</p>
          <div className="mb-2-UP grey-color-font">
            <button className="cr-cancel-btn me-cs4" onClick={handleCancel}>
              CANCEL
            </button>
            <button className="cr-create-btn" onClick={handleGenerateClick}>
              GENERATE
            </button>
          </div>
        </div>
        <hr className="hr-otc" />
      </div>

      <div style={{ paddingLeft: "15px", paddingTop: "15px", paddingBottom: "8px" }}>
        <p className="color424342" style={{ marginBottom: "15px", fontSize: "16px" }}>
          Report generation and Report sending to WhatsApp
        </p>
        <div style={{ display: "flex" }}>
          <DropDown
            key="course-dropdown"
            setSelected={(courseId, label) => {
              setCourseOpted(courseId);   // Set the selected course
              setSelectedBatchId("");      // Clear the selected batch
              setBatchNameByCourseID([]);  // Clear batch options to reset the dropdown
              setSelectedStudent({ name: "", id: null }); // Clear the selected student
              setSearchKeySecond("");      // Clear the search input field
              setSelectedCourseLabel(label);  // Set course label
              setSelectedBatchLabel("");   // Reset batch label
              fetchBatchesForCourse(courseId);  // Fetch batches for selected course
            }}
            options={courses.map((course) => ({
              label: course.course_name,
              id: course.course_id,
            }))}
            selectedLabel={selectedCourseLabel}  // Control the selected label from parent
            Height="auto"
            minheight="150px"
            OverFlow="auto"
            customWidth="300px"
            label="Course"
          />
          <div className="whatsapp-div color424342" style={{ paddingLeft: "40px" }}>
            <ul>
              <li style={{ paddingBottom: "8px" }}>
                <label style={{ padding: "" }}>WhatsApp</label>
              </li>
              <li>
                <label className={`switch user-status ${whatsappFlag ? "no-border" : ""}`}>
                  <input
                    type="checkbox"
                    checked={whatsappFlag}
                    onChange={() => setWhatsappFlag(!whatsappFlag)}
                  />
                  <span className="slider round"></span>
                </label>
              </li>
            </ul>
          </div>
        </div>

        <div style={{ display: "flex" }}>
          <DropDown
            key="batch-dropdown"
            setSelected={(batchId, label) => {
              setSelectedBatchId(batchId); // Set the selected batch
              setSelectedStudent({ name: "", id: null }); // Clear the selected student
              setSearchKeySecond(""); // Clear the search input field
              setSelectedBatchLabel(label);  // Set batch label
            }}
            options={
              batchnameByCourseID && Array.isArray(batchnameByCourseID[0])
                ? batchnameByCourseID[0].map((batch) => ({
                    label: batch.batch_name,
                    id: batch.batch_id,
                  }))
                : []
            }
            selectedLabel={selectedBatchLabel}  // Control the selected label from parent
            Height="auto"
            minheight="150px"
            OverFlow="auto"
            customWidth="300px"
            label="Batch"
          />
          <div className="whatsapp-div color424342" style={{ paddingLeft: "40px" }}>
            <ul>
              <li style={{ paddingBottom: "8px" }}>
                <label>Download Report</label>
              </li>
              <li>
                <label className={`switch user-status ${downloadFlag ? "no-border" : ""}`}>
                  <input
                    type="checkbox"
                    checked={downloadFlag}
                    onChange={() => setDownloadFlag(!downloadFlag)}
                  />
                  <span className="slider round"></span>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <label style={{ color: "#424242", marginLeft: "15px" }}>Search Student</label>
      <div
        style={{
          marginTop: "8px",
          border: "1px solid grey",
          position: "relative",
          display: "flex",
          alignItems: "center",
          width: "300px",
          marginLeft: "0.85vw",
        }}
      >
        <input
          style={{
            backgroundColor: "white",
            outline: "none",
            padding: "10px",
            width: "70vw",
            height: "3.4vh",
            border: "none",
          }}
          type="text"
          placeholder="Type here to search"
          name="search"
          value={searchKeySecond}
          onChange={(e) => setSearchKeySecond(e.target.value)}
          onFocus={() => setIsDropdownVisible(true)}
          onBlur={() => setTimeout(() => setIsDropdownVisible(false), 200)}
        />
        <img
          style={{ height: "3.4vh", width: "2vw", backgroundColor: "none", padding: "4px" }}
          src={Search}
          alt="search"
        />
        {isDropdownVisible && searchResults.length > 0 && (
          <div className="search-results-dropdown">
            {searchResults.map((result, index) => (
              <div key={index} className="search-result-item" onClick={() => handleStudentSelect(result)}>
                <p className="first-item-student">
                  <img
                    src={StudentLogo}
                    style={{
                      height: "25px",
                      width: "25px",
                      marginRight: "4px",
                    }}
                    alt=""
                  />
                  {formatStudentName(result.student_name)}
                </p>
                <p style={{ marginTop: "5px" }} className="second-item-student">
                  {/* Batch: {result.batch_name} */}
                </p>
                <p className="second-item-student">Roll No: {result.student_roll_no}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportWhatsapp;
